import HttpService from "~/Scripts/services/httpService";

const instance = new HttpService( "umbraco/surface/LmMyAccountSurface/" );

/* eslint-disable arrow-body-style */

/**
 * Change the web account's password.
 * @param {*} currentPassword The current web account password.
 * @param {*} newPassword The new web account password.
 */
export const changePassword = ( currentPassword, newPassword ) => {
  return instance.post( "ChangePassword", {
    currentPassword,
    newPassword,
  } );
};

/**
 * Closes the web account.
 */
export const closeAccount = () => {
  return instance.post( "CloseAccount" );
};

/**
 * Save welcome preference.
 */
export const saveWelcomePreference = ( preference ) => {
  return instance.post( "SaveWelcomePreference", null, {
    doNotShowAgain: preference,
  } );
};
